import * as coreClient from "@azure/core-client";

export interface Order {
  /** NX Order Number */
  orderNumber: string;
  /** ISO 8601 Date Format */
  orderDate: string;
  /** NX Order Status */
  orderstatus: string;
  /** Total Amount value of All Order Line Items (SUM of orderLine.paidPrice) also After Discount Applied */
  orderTotal?: number;
  orderLines?: OrderLine[];
  customer?: Customer;
  discount?: OrderDiscount;
}

export interface OrderLine {
  /** Ticket Product ID */
  itemId: number;
  /** Ticket Code (either mTicketID or SwiftTicketID - example with SwiftTicketID) */
  ticketTypeId: string;
  /** Quantity of OrderLine Item */
  quantity: number;
  /** Price of OrderLine Item with Quantity as 1 */
  itemPrice: number;
  /** Total Price of Basket Item - Item Price multiply with provided Quanity (temporary field to avoid breaking change and value same as subTotalPrice) */
  price?: number;
  /** Total Price of Basket Item - Item Price multiply with provided Quanity (itemPrice * quantity) */
  subTotalPrice: number;
  /** Total Price Paid for Basket Item is Sub Total Price minus Order Line Discount Value for matched Ticket (subTotalPrice - discount.discountItems.discountValue) */
  paidPrice: number;
  applicants: Applicant[];
}

export interface Applicant {
  /** Ticket Product ID */
  itemId: number;
  /** Ticket Product Quantity Index (If there are Multiple Quantity, this field will represent each index of that quantity) */
  quantityIndex: number;
  fulfillmentMethod: string;
  /** Payment Type of Price for the OrderLine Item */
  paymentMethodType: ApplicantPaymentMethodType;
  customer: Customer;
  /** ISO 8601 Date Format */
  startDate: string;
}

export interface Customer {
  id: string;
  firstName: string;
  lastName: string;
  /** ISO 8601 Date Format */
  dateOfBirth: string;
  mobileNumber: string;
  emailAddress: string;
  address?: Address;
}

export interface Address {
  /** First Address Line */
  address1: string;
  /** Second Address Line */
  address2?: string;
  /** Locality or Town */
  town: string;
  /** Postal Code */
  postCode: string;
}

export interface OrderDiscount {
  /** Total Discount Value Applied As Discount considering All Products in Cart (Basket) */
  totalDiscountValue: number;
  /** Discount Label to be Used for Display (will be received from Talon response) */
  discountLabel: string;
  discountItems: OrderLineDiscount[];
}

export interface OrderLineDiscount {
  /** Ticket Product ID */
  ticketID: number;
  /** Discount Value To be Applied As Discount On Product (will be received from Talon response) as 1.75 - 10% discount per Item Price * quantity */
  discountValue: number;
}

export interface ApiError {
  code?: number;
  shortDescription?: string;
  description?: string;
}

/** Known values of {@link HostOptions} that the service accepts. */
export enum KnownHostOptions {
  /** host: https:\//nxbus.api.nationalexpress.com */
  HttpsNxbusApiNationalexpressCom = "https://nxbus.api.nationalexpress.com",
  /** host: https:\//perfnxbus.api.nationalexpress.com */
  HttpsPerfnxbusApiNationalexpressCom = "https://perfnxbus.api.nationalexpress.com",
  /** host: https:\//dt8nxbus.api.nationalexpress.com */
  HttpsDt8NxbusApiNationalexpressCom = "https://dt8nxbus.api.nationalexpress.com",
  /** host: https:\//dt6nxbus.api.nationalexpress.com */
  HttpsDt6NxbusApiNationalexpressCom = "https://dt6nxbus.api.nationalexpress.com"
}

/**
 * Defines values for HostOptions. \
 * {@link KnownHostOptions} can be used interchangeably with HostOptions,
 *  this enum contains the known values that the service supports.
 * ### Known values supported by the service
 * **https:\//nxbus.api.nationalexpress.com**: host: https:\/\/nxbus.api.nationalexpress.com \
 * **https:\//perfnxbus.api.nationalexpress.com**: host: https:\/\/perfnxbus.api.nationalexpress.com \
 * **https:\//dt8nxbus.api.nationalexpress.com**: host: https:\/\/dt8nxbus.api.nationalexpress.com \
 * **https:\//dt6nxbus.api.nationalexpress.com**: host: https:\/\/dt6nxbus.api.nationalexpress.com
 */
export type HostOptions = string;

/** Known values of {@link ApplicantPaymentMethodType} that the service accepts. */
export enum KnownApplicantPaymentMethodType {
  /** OneOff */
  OneOff = "One Off",
  /** Subscription */
  Subscription = "Subscription"
}

/**
 * Defines values for ApplicantPaymentMethodType. \
 * {@link KnownApplicantPaymentMethodType} can be used interchangeably with ApplicantPaymentMethodType,
 *  this enum contains the known values that the service supports.
 * ### Known values supported by the service
 * **One Off** \
 * **Subscription**
 */
export type ApplicantPaymentMethodType = string;

/** Optional parameters. */
export interface GetOrderByOrderNumberOptionalParams
  extends coreClient.OperationOptions {}

/** Contains response data for the getOrderByOrderNumber operation. */
export type GetOrderByOrderNumberResponse = Order;

/** Optional parameters. */
export interface OrderAPIOptionalParams
  extends coreClient.ServiceClientOptions {
  /** server parameter */
  $host?: HostOptions;
  /** Overrides client endpoint. */
  endpoint?: string;
}
